<template>
  <div id="UNBARRING_PIN" class="container-fixed offset-bottom-6">
    <VProgress class="offset-top-2 offset-bottom-2" :steps="steps" active="unbarring.pin" />

    <p class="offset-bottom-2 offset-top-2" v-html="$tc('unbarring.pinDescription', partnerName)"></p>

    <VForm :form="form" @submit="onNext">
      <VInput name="pin" :label="$t('unbarring.pinLabel')" :hint="$t('errorcodes.WRONG_PIN')" required />

      <div class="offset-top-2 text-right">
        <transition name="fade" mode="out-in" appear>
          <VSpinner v-if="isBusy" slim class="pull-left" />
        </transition>
        <VButton type="button" class="offset-left-1 offset-bottom-1 btn-clean" label="unbarring.abort" @click="redirect" />
        <VButton type="submit" class="offset-left-1 offset-bottom-1 btn-default btn-brand" label="unbarring.submit" :disabled="isBusy" />
      </div>
    </VForm>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import TitleMixin from '@/mixins/title';
import UnbarringSteps from '@/mixins/unbarringSteps';
import VSpinner from '@/components/Spinner';
import Proxy from '@/proxies/UnbarringProxy';
import VForm from '@/components/Form/Form';
import VInput from '@/components/Form/Input';
import { initFields, focusFirstError } from '@/utils/form';

export default {
  name: 'UnbarringAccess',

  components: {
    VSpinner,
    VForm,
    VInput,
    VProgress: () => import('@/components/Progress'),
    VButton: () => import('@/components/Button'),
  },

  mixins: [TitleMixin, UnbarringSteps],

  props: {
    isAuthorized: {
      type: Boolean,
      required: false,
    },

    hasPin: {
      type: Boolean,
      required: false,
    },

    partnerName: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      isBusy: false,
      form: initFields({ name: 'pin' }),
    };
  },

  methods: {
    ...mapActions('unbarring', ['redirect']),

    async onNext({ values }) {
      this.isBusy = true;
      try {
        await new Proxy().pin(values);
        this.redirect();
      } catch (error) {
        const code = error?.data?.code;
        if (code === 'UNBARRING_WRONG_PIN') {
          this.form.pin.setInvalid();
        } else {
          throw error;
        }
        focusFirstError(this.form);
        this.isBusy = false;
      }
    },
  },
};
</script>
